import _ from 'lodash';
import { SORTED_ADDRESS_ABBREVIATION_MAPPING } from '../../../constants/constants';

export const abbreviateAddress = (address: string) => {
  if (!address) {
    return '';
  }
  let transferAddressStr = address + ' ';
  _.map(SORTED_ADDRESS_ABBREVIATION_MAPPING, (item) => {
    transferAddressStr = transferAddressStr.replace(
      new RegExp(item.Type + ' ', 'g'),
      item.Abbreviation + ' ',
    );
  });
  return transferAddressStr.trim();
};

export const removeChineseCharacters = (value: string) => {
  if (!value) {
    return value;
  }
  return value.replace(/[\u4e00-\u9fa5]{1,}/g, '');
};

export const normaliseAddress = (address: string) => {
  return abbreviateAddress(removeChineseCharacters(address));
};
